<template>
  <div>
    <!-- Page Header -->
    <div class="page-header-modern">
      <div class="page-header-inner">
        <h2 class="font-28">Pertanyaan Umum (FAQ)</h2>
        <div class="breadcrumb-modern">
          <a href="/">Home</a>
          <span>/</span>
          <span class="bc-active">FAQ</span>
        </div>
      </div>
    </div>

    <div class="container-standar" style="padding-top: 56px; padding-bottom: 80px;">
      <div class="text-center" style="margin-bottom: 48px;">
        <span class="section-label">Bantuan</span>
        <h2 class="section-title">Ada yang ingin ditanyakan?</h2>
        <p class="section-subtitle">
          Temukan jawaban atas pertanyaan yang sering diajukan seputar Aplikasi SIOPAPUA.
        </p>
      </div>

      <div class="faq-section">
        <div
          v-for="(item, index) in faqs"
          :key="index"
          class="faq-item"
          :class="{ 'faq-open': openIndex === index }"
        >
          <div
            class="faq-question"
            :class="{ open: openIndex === index }"
            @click="toggle(index)"
          >
            <span class="faq-q-number">{{ index + 1 }}</span>
            <span class="faq-q-text">{{ item.question }}</span>
            <span class="faq-toggle-icon">
              <b-icon icon="chevron-down" font-scale="0.9"></b-icon>
            </span>
          </div>
          <transition name="faq-slide">
            <div v-if="openIndex === index" class="faq-answer">
              {{ item.answer }}
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      openIndex: 0,
      faqs: [
        {
          question: "Apa itu Aplikasi SIOPAPUA?",
          answer: "Sistem Aplikasi SIOPAPUA adalah Aplikasi penjaring data kampung dan kelurahan di seluruh wilayah Papua yang berfungsi untuk meningkatkan kualitas pengelolaan data dan informasi dasar kampung sehingga dapat mendukung administrasi pemerintahan, perencanaan pembangunan, peningkatan layanan dasar, dan pengembangan kegiatan ekonomi kampung.",
        },
        {
          question: "Mengapa kampung harus menggunakan Aplikasi SIOPAPUA?",
          answer: "Aplikasi SIOPAPUA ini dapat meningkatkan tata kelola pemerintahan dan pembangunan di tingkat kampung / kelurahan dan distrik dalam bidang ekonomi & pelayanan dasar sehingga dapat memperkuat pemerintah provinsi, kabupaten, dan kampung dalam menjalankan tugas yang ditetapkan peraturan perundang-undangan.",
        },
        {
          question: "Apa akibatnya jika kampung menolak menggunakan Aplikasi SIOPAPUA?",
          answer: "Data Kampung di Aplikasi SIOPAPUA digunakan sebagai acuan data untuk mendukung administrasi pemerintahan, perencanaan pembangunan, peningkatan layanan dasar & pengembangan kegiatan ekonomi kampung. Apabila kampung tidak berpartisipasi aktif, maka kampung akan rugi karena sistem administrasi dan informasi kampung tidak dikelola dengan baik sehingga kampung tersebut otomatis tidak akan tersentuh program-program Pemerintah Daerah Papua.",
        },
        {
          question: "Apakah hanya wilayah Papua saja yang dapat menggunakan Aplikasi SIOPAPUA?",
          answer: "Ya, semua kampung dan kelurahan di Provinsi Papua.",
        },
        {
          question: "Bagaimana cara mendaftarkan kampung yang belum punya akses SIOPAPUA?",
          answer: "Kampung mendaftarkan ke dinas terkait dengan menyurat atas nama kepala kampung.",
        },
      ],
    };
  },
  mounted() {
    this.$store.commit("SET_BG", false);
  },
  methods: {
    toggle(index) {
      this.openIndex = this.openIndex === index ? null : index;
    },
  },
};
</script>

<style scoped>
.faq-slide-enter-active,
.faq-slide-leave-active {
  transition: all 0.28s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}
.faq-slide-enter,
.faq-slide-leave-to {
  opacity: 0;
  max-height: 0;
  padding-bottom: 0;
}
.faq-slide-enter-to,
.faq-slide-leave {
  opacity: 1;
  max-height: 500px;
}
</style>
